
import { useEffect, useRef, useState } from 'react'
import CustomFilter from '../../../../CommonComponents/custom_filter/CustomFilter'
import { AllFilterType } from '../../../../CommonComponents/custom_filter/types'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import useMonitor from '../../../hooks/useMonitor'
import useScenario from '../../../hooks/useScenario'
import useUrlNavigation from '../../../hooks/useUrlNavigation'
import useUrlParams from '../../../hooks/useUrlParams'
import useViewer from '../../../hooks/useViewer'
import ADCS from '../../grafana_panels/ADCS'
import Beacon from '../../grafana_panels/Beacon'
import Communication from '../../grafana_panels/Communication'
import EPS from '../../grafana_panels/EPS'
import OBC from '../../grafana_panels/OBC'
import Payload from '../../grafana_panels/Payload'
import Propulsion from '../../grafana_panels/Propulsion'
import './Monitor.scss'
import { get_monitor_button_list, Monitor_view } from './utils'
import { isOperateMode } from '../../../hooks/utils'


const Monitor = () => {
    const { dashboard } = useUrlParams()
    const { navigate_to } = useUrlNavigation()
    const { panels, selected_panel, change_selected_panel, monitor_view_type, handleFileUpload, change_monitor_view_type, fileName, get_updated_url } = useMonitor()
    const { set_telemetry_time } = useMonitor()
    const { scenario } = useScenario()
    const { viewer } = useViewer()
    const containerRef = useRef<HTMLDivElement>(null)

    const isValidateSummary = scenario?.scenarioDeploymentType?.toUpperCase() === 'VALIDATE' && dashboard === 'summary'

    if (!viewer && !isValidateSummary) {
        navigate_to('hud')
    }
    const [allFilters, setAllFilters] = useState<AllFilterType>({ timeFilter: { startTime: null, endTime: null } })
    const operateMode = isOperateMode(dashboard, scenario)

    //SCROLL TO TOP WHEN SLECTED PANEL CHANGE
    useEffect(() => {
        if (!viewer) return
        if (containerRef.current) {
            containerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }, [selected_panel, viewer]);

    useEffect(() => {
        set_telemetry_time(null)
    }, [])

    const handleChangeFilter = (filters) => {
        if (filters?.timeFilter?.startTime && filters?.timeFilter?.endTime) {
            set_telemetry_time([
                filters?.timeFilter?.startTime,
                filters?.timeFilter?.endTime
            ]);
        } else {
            set_telemetry_time(null)
        }
    }

    return (
        <div className='monitor__container__wrapper'>
            <div className='monitor__container'>
                <div className='monitor__container__header'>
                    <div className='monitor__header__left__container'>
                        {get_monitor_button_list(scenario, dashboard).map((btn: { label: string, value: string, disabled?: boolean }) => {
                            const remoteConfigured = (scenario?.scenarioDeploymentType === 'HARDWARE_IN_LOOP') && scenario?.hwInfo?.find(item => item.category === btn?.value);
                            return (
                                <div className={`button-wrapper`}>
                                    <button
                                        className={`button ${selected_panel === btn.value ? 'active' : ''}`}
                                        onClick={() => change_selected_panel(btn.value)}
                                    >
                                        {btn.label}
                                        {remoteConfigured && <div className='button__badge'>{'HWIL'}</div>}
                                    </button>
                                </div>
                            );
                        })}

                    </div>
                    <div className='monitor__header__right__container'>
                        {operateMode && (
                            <button
                                className="button cursor-pointer"
                                onClick={handleFileUpload}
                            >
                                <CustomToolTip title={"Upload File"} placement='top'>
                                    <i className="fe fe-upload fs-25 color-text"></i>
                                </CustomToolTip>
                            </button>
                        )}
                        {fileName && <p className='m-0'>{fileName}</p>}
                        {Monitor_view.map((view: { title: string, icon: JSX.Element }) => (
                            <button
                                className={`button ${monitor_view_type === view.title && 'active'}`}
                                onClick={() => change_monitor_view_type(view.title)}
                            >
                                <CustomToolTip title={view.title} placement='top'>
                                    {view.icon}
                                </CustomToolTip>
                            </button>
                        ))}
                        {operateMode &&
                            <div className='ms-1'>
                                <CustomFilter
                                    alignment='right'
                                    timeFilter={{
                                        applyFilter: (filters: { [key: string]: any }) => { handleChangeFilter(filters) }
                                    }}
                                    allFilters={allFilters}
                                    setAllFilters={setAllFilters}
                                    filterCase={'simulate'}
                                    boundingScreen={'simulate__details__page'}
                                />
                            </div>
                        }
                    </div>
                </div>
                <div className='monitor__container__body' ref={containerRef}>
                    {selected_panel === 'Beacon' && <Beacon monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'EPS' && <EPS monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'OBC' && <OBC monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'ADCS' && <ADCS monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'Communication' && <Communication monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'Propulsion' && <Propulsion monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                    {selected_panel === 'Payload' && <Payload monitor_view_type={monitor_view_type} panels={panels} get_updated_url={get_updated_url} />}
                </div>
            </div>
        </div>
    )
}

export default Monitor